import { validate } from "com";
import { USER_ENDPOINTS } from "./endpoints";
import { apiPost } from "../shared";
import { ResetPasswordPayload, ResetPasswordResponse } from "./types";

export default async function resetPassword(
  email: string,
  token: string,
  newPassword: string
): Promise<ResetPasswordResponse> {
  validate.email(email);
  validate.password(newPassword);

  if (!token || typeof token !== "string" || token.trim().length === 0) {
    throw new Error("Reset token is required");
  }

  const payload: ResetPasswordPayload = {
    email,
    token,
    newPassword,
  };

  return await apiPost<ResetPasswordResponse>(USER_ENDPOINTS.RESET_PASSWORD, payload);
}
